import React, { useRef, useState } from "react";
import OptionButtons from "../../../../../../components/buttons/optionsBtn";
import Uploader from "../uploader";
import { extractFileId, QUESTION_TYPES } from "../../../../../../utils/data";
import {
  removeImage,
  uploadImageApi,
} from "../../../../../../api/apis/assesments";
import { getAssessmentData } from "../../../../../../functions/localStorage";
import { parseIfStringify, removeSpaceAndUppercase } from "../../../../../../functions/common";

const YesNoText = ({
  data,
  handleAnswer,
  answers,
  setUploadLoading,
  uploadLoading,
  currentIndex,
  notApplicable,
  responseType
}) => {
  const [textArea, setTextArea] = useState("");
  const splittesAnswer = answers?.[data?.refCode]?.split(" + ");
  const selectedOption = splittesAnswer?.[0] ?? "";
  const inputText = splittesAnswer?.[1] ?? "";
  const inputRef = useRef();
  const { locationId, assessmentId } = getAssessmentData() ?? {};
  const images = parseIfStringify(
    answers?.[data?.refCode]?.split(" + ")?.[2]?.replace("", "") ?? []
  );
  const withText = responseType?.includes("+ Text");

  const handleResponseChange = (label) => {
    const formattedAnswer = `${label} + ${inputText}${
      data?.supportingDoc
        ? ` + ${JSON.stringify(images)}`
        : ""
    }`;
    if (label === "No") {
      handleAnswer(
        (data?.responseType !== "YN+AL-Text" && removeSpaceAndUppercase(data?.responseType) === removeSpaceAndUppercase(QUESTION_TYPES.YESNONOTAPPLICABLE)) ? "No" : formattedAnswer
      );
    } else {
      handleAnswer(formattedAnswer);
    }
  };

  const handleDelete = (item) => {
    const driveId = extractFileId(item?.viewLink);
    const updatedimages = images?.filter(v => v?.viewLink !== item?.viewLink);
    handleAnswer(`${selectedOption} + ${inputText} + ${JSON.stringify(updatedimages)}`);
    if (driveId) removeImage(driveId);
  };

  const handleFileUpload = async (file) => {
    if (file) {
      setUploadLoading(true);
      const imageData = await uploadImageApi(
        {
          file: file,
          ref: data?.refCode,
        },
        locationId,
        assessmentId
      );
      setUploadLoading(false);
      const fileData = {
        fileName: imageData?.data?.fileName,
        viewLink: imageData?.data?.viewLink,
      };
      const updatedImages = [...images, fileData];
      const formattedAnswer = `${selectedOption} + ${inputText} + ${JSON.stringify(updatedImages)}`;
      handleAnswer(formattedAnswer);
      inputRef.current.value = "";
    }
  };

  const handleAdditionalTextChange = (text) => {
    const formattedAnswer = `${selectedOption} + ${text}${
      data?.supportingDoc
        ? ` + ${JSON.stringify(images)}`
        : ""
    }`;
    handleAnswer(formattedAnswer);
  };

  return (
    <div className="yes__text__new">
      <div className="yes__text__options">
        <OptionButtons
          selected={selectedOption}
          onSelect={(label) => handleResponseChange(label)}
          value={textArea}
          notApplicable={notApplicable}
          responseType={responseType}
        />
      </div>
      {(selectedOption === "Yes" || data?.responseType === "YN+AL-Text") && (!notApplicable || withText) && (
        <>
          <div className="yes__text__comment">
            <p>{data?.prompt}</p>
            <textarea
              rows="5"
              value={inputText}
              onChange={(e) => {
                const updatedText = e.target.value;
                setTextArea(updatedText);
                handleAdditionalTextChange(updatedText);
              }}
              required={true}
            ></textarea>
          </div>
          {data?.supportingDoc ? (
            <Uploader
              images={images}
              inputRef={inputRef}
              handleFileUpload={handleFileUpload}
              handleUpload={handleFileUpload}
              handleDelete={handleDelete}
              uploadLoading={uploadLoading}
              data={data}
              currentIndex={currentIndex}
            />
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default YesNoText;
